import { render } from "./ResponsiveImage.vue?vue&type=template&id=92b22a0a&scoped=true&ts=true"
import script from "./ResponsiveImage.vue?vue&type=script&lang=ts"
export * from "./ResponsiveImage.vue?vue&type=script&lang=ts"

import "./ResponsiveImage.vue?vue&type=style&index=0&id=92b22a0a&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92b22a0a"]])

export default __exports__